export enum ModuleModeEnum {
    LECTURE = 1, // 선생님 혼자 수업 진행
    SELF = 2, // 학생 혼자 진행
}

export const moduleModeText = {
    [ModuleModeEnum.LECTURE]: '수업',
    [ModuleModeEnum.SELF]: '자습',
};

export const moduleModeColor: Record<ModuleModeEnum, string> = {
    [ModuleModeEnum.LECTURE]: 'danger',
    [ModuleModeEnum.SELF]: 'primary',
};